import { queryOptions, UseQueryOptions } from '@tanstack/react-query'
import { BudgetingScenario } from '../../types/BudgetingScenario'
import { getForecastOptions } from './getForecastOptions'

type UseForecastOptionsProps<TData> = {
  companyId: string
  select?: (data: BudgetingScenario[]) => TData
}

export const useForecastOptions = <TData = BudgetingScenario[]>({
  companyId,
  select
}: UseForecastOptionsProps<TData>) => {
  return queryOptions(getForecastOptions(companyId, select)) as UseQueryOptions<TData>
}
